/**
 * Service execution v2 — shared domain contracts.
 *
 * Architecture: docs/source-of-truth/worker-service-delivery-architecture.md
 * Matrix:       docs/source-of-truth/worker-service-execution-matrix.md
 *
 * This package is the only owner of pack semantics. Web and mobile consume
 * these types and must not maintain a local service-code switch table.
 */

export * from './authority';
export * from './composition';
export * from './decisions';
export * from './evidence';
export * from './evidence-invariants';
export * from './evidence-migrations';
export * from './finance-owner';
export * from './iddsi';
export * from './execution-modes';
export * from './packs';
export * from './projection';
export * from './registry';
export * from './resolver';
